import { DateUtils, DynpackRoomUtils, HotelRoomUtils } from '../../utils';
import { composeRoomParams } from './composeRoomParams';
import { DpPaxRestrictionPropsDefault } from '../../models';
import { SegmentParams } from './composeSegmentParams';

export const composeDynpackParams = (search = {}) => {
    const limitRooms = HotelRoomUtils.getRoomsAvailableByRestrictions(search.rooms, DpPaxRestrictionPropsDefault);
    const rooms = DynpackRoomUtils.getRoomSelection(search.pax, limitRooms, search.activeProduct);
    let url = SegmentParams.compose(search);

    url += composeRoomParams(rooms);

    if (search.separateStay && search.separateStay.enabled) {
        url += `;checkInDate=${DateUtils.formatDate(
            search.separateStay.checkInDate,
            'yyyy-mm-dd',
        )}`;
        url += `;checkOutDate=${DateUtils.formatDate(
            search.separateStay.checkOutDate,
            'yyyy-mm-dd',
        )}`;
    }
    return url;
};
